function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import i18n from 'invision-core/src/components/i18n/i18n';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import CustomerLocaleKeys from '../../../../../../../locales/keys';
import { UNIT_OF_MEASURES } from '../../../../../../../customercare.constants';
import { entitlementBalanceUpdate, retrieveEntitlementsToUpdate, setSelectedEntitlement } from '../..../../../../../../../../reducers/actions/entitlement.balance.update.modal.actions';
import { ConvergentBillerCurrencyCodeSelector } from '../../../../../../../reducers/selectors/customer.convergent.biller.selectors';
import { retrieveServiceDetails } from '../../../../../../../reducers/actions/services.actions';
import { IsLoadingEntitlementBalancesSelector, ServiceEntitlementsSelector, SharedEntitlementsSelector, UnitOfMeasuresSelector } from '../../../../../../../reducers/selectors/entitlement.balance.update.modal.selectors';
export var EditEntitlementModalController = /*#__PURE__*/function () {
  function EditEntitlementModalController($ngRedux, uiNotificationService) {
    _classCallCheck(this, EditEntitlementModalController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerLocaleKeys: CustomerLocaleKeys,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(EditEntitlementModalController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.isLoading = false;
      this.disableConfirm = true;
      this.entitlementsToUpdate = [];
      this.selectedEntitlement = undefined;
      this.adjustRemainingBalanceBy = [];
      var controllerActions = {
        entitlementBalanceUpdate: entitlementBalanceUpdate,
        retrieveEntitlementsToUpdate: retrieveEntitlementsToUpdate,
        retrieveServiceDetails: retrieveServiceDetails,
        setSelectedEntitlement: setSelectedEntitlement
      };
      var mapStateToProps = function mapStateToProps(store) {
        return {
          currencyCode: ConvergentBillerCurrencyCodeSelector(store),
          isLoadingEntitlementBalances: IsLoadingEntitlementBalancesSelector(store),
          serviceEntitlementItems: ServiceEntitlementsSelector(store),
          sharedEntitlementItems: SharedEntitlementsSelector(store),
          unitOfMeasures: UnitOfMeasuresSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToProps, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.retrieveEntitlementBalancesForEdit();
    }
  }, {
    key: "updateEntitlement",
    value: function updateEntitlement() {
      var _this2 = this;
      this.isLoading = true;
      var updateEntitlementRequest = {
        Amount: this.adjustRemainingBalanceBy[0].value,
        BalanceUnitCode: this.adjustRemainingBalanceBy[0].type,
        EntitlementIdentifier: this.selectedEntitlement.EntitlementIdentifier,
        ExpirationDate: this.selectedEntitlement.ExpirationDate,
        Reason: this.reasonDescription
      };
      this.actions.entitlementBalanceUpdate(updateEntitlementRequest, this.currentCustomerId).then(function () {
        var serviceIdentifiers = [{
          Value: _this2.serviceIdentifier.Value
        }];
        _this2.isLoading = false;
        _this2.uiNotificationService.success(i18n.translate(_this2.CustomerLocaleKeys.CUSTOMER_DASHBOARD.SERVICES_WIDGET.ENITITLEMENT_UPDATE_SUCCESS));
        _this2.actions.retrieveServiceDetails(_this2.currentCustomerId, serviceIdentifiers);
      }).catch(function (error) {
        _this2.uiNotificationService.transientError(error.translatedMessage);
      }).finally(function () {
        _this2.cancelEditEntitlementModal();
      });
    }
  }, {
    key: "handleFormChanged",
    value: function handleFormChanged() {
      this.disableConfirm = !(this.adjustRemainingBalanceBy && this.reasonDescription);
    }
  }, {
    key: "cancelEditEntitlementModal",
    value: function cancelEditEntitlementModal() {
      this.actions.setSelectedEntitlement({});
      this.onClose();
    }
  }, {
    key: "onEntitlementChange",
    value: function onEntitlementChange() {
      this.editEntitlementForm.$setPristine();
      if (this.selectedEntitlement) {
        this.adjustRemainingBalanceBy = [{
          type: +this.selectedEntitlement.BalanceUnitCode,
          value: null
        }];
        this.reasonDescription = '';
        this.disableConfirm = true;
      }
      this.actions.setSelectedEntitlement(this.selectedEntitlement);
      this.uomDropdownOptions = clone(this.state.unitOfMeasures);
    }
  }, {
    key: "retrieveEntitlementBalancesForEdit",
    value: function retrieveEntitlementBalancesForEdit() {
      var _this3 = this;
      this.actions.retrieveEntitlementsToUpdate(this.currentCustomerId, this.serviceIdentifier).then(function () {
        var entitlementsToUpdate = _this3.isShared ? _this3.state.sharedEntitlementItems : _this3.state.serviceEntitlementItems;
        _this3.dropdownEntitlementItems = entitlementsToUpdate.filter(function (entitlement) {
          return entitlement.BalanceUnitCode !== UNIT_OF_MEASURES.CURRENCY && entitlement.OwningSubscriberId === convertStringToNumber(_this3.currentCustomerId);
        });
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  controller: EditEntitlementModalController,
  controllerAs: 'EditEntitlementModalController',
  template: require('./edit.entitlement.html'),
  bindings: {
    currentCustomerId: '<',
    isShared: '<',
    onClose: '&',
    serviceIdentifier: '<'
  }
};